import AutoLayout from "../../../../../AutoLayout/AutoLayout";
import React from "react";
import styled from "styled-components";
import {
  AutoLayoutAlignEnum,
  AutoLayoutDirectionEnum,
} from "../../../../../AutoLayout/AutoLayoutEnums";

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

interface ActionButtonsProps {
  children: React.ReactNode;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ children }) => {
  return (
    <AutoLayout $direction={AutoLayoutDirectionEnum.HORIZONTAL} $align={AutoLayoutAlignEnum.RIGHT}>
      <ActionsRow>{children}</ActionsRow>
    </AutoLayout>
  );
};

export default ActionButtons;
